/**
 * notices.js
 */

import React from "react";
// import DogAttributesNotice from './dog-attributes';

export default function Notices(props) {

  return (
    <>
      {/* <DogAttributesNotice /> */}
    </>
  );
}